import React from 'react';
import { CheckCircle2, ArrowRight } from 'lucide-react';
import { heroImages } from '../mock';

export default function FeatureShowcase() {
  const rows = [
    {
      title: 'End-to-End Marketplace Management',
      desc: 'From onboarding to daily operations — we handle listings, catalog, ads, and returns so your brand runs smoothly across 8+ marketplaces.',
      points: ['Seller Central Setup', 'A+ Content & Listings', 'PPC Ads Management', 'Returns & Support'],
      img: heroImages.warehouse,
      reverse: false,
      accent: 'var(--brand-green)',
    },
    {
      title: 'Social Media that Actually Sells',
      desc: 'Instagram & Facebook growth strategies that build community and convert followers into paying customers. Content, reels, ads and analytics — all covered.',
      points: ['Content Calendar', 'Reels & Video', 'Meta Ads', 'Influencer Marketing'],
      img: heroImages.social,
      reverse: true,
      accent: 'var(--brand-orange)',
    },
    {
      title: 'Websites Built to Convert',
      desc: 'Fast, mobile-first, SEO-optimized websites and Shopify/WooCommerce stores designed to turn visitors into customers.',
      points: ['Custom Design', 'Shopify & Woo Stores', 'Landing Pages', 'SEO & Maintenance'],
      img: heroImages.coding,
      reverse: false,
      accent: 'var(--brand-green)',
    },
  ];

  return (
    <section className="section bg-[color:var(--brand-green-light)]/30">
      <div className="container-x space-y-24">
        {rows.map((r, i) => (
          <div
            key={i}
            className={`grid lg:grid-cols-2 gap-10 lg:gap-16 items-center ${r.reverse ? 'lg:[direction:rtl]' : ''}`}
          >
            <div className="[direction:ltr]">
              <div className="relative rounded-3xl overflow-hidden shadow-2xl border-4 border-white">
                <img src={r.img} alt={r.title} className="w-full h-[380px] object-cover" />
                <div
                  className="absolute inset-0"
                  style={{ background: `linear-gradient(180deg, transparent 60%, ${r.accent}30 100%)` }}
                />
              </div>
            </div>
            <div className="[direction:ltr]">
              <div
                className="inline-block px-4 py-1.5 rounded-full text-xs font-bold uppercase tracking-widest mb-4"
                style={{ background: `${r.accent}18`, color: r.accent }}
              >
                Feature {i + 1}
              </div>
              <h3 className="text-3xl md:text-4xl font-black text-[color:var(--ink)] leading-tight">
                {r.title}
              </h3>
              <p className="section-sub mt-4">{r.desc}</p>
              <div className="mt-6 grid grid-cols-2 gap-3">
                {r.points.map((p) => (
                  <div key={p} className="flex items-center gap-2 text-sm font-semibold text-[color:var(--ink)]">
                    <CheckCircle2 size={18} style={{ color: r.accent }} />
                    {p}
                  </div>
                ))}
              </div>
              <a href="/services" className="btn-primary mt-6">
                Explore <ArrowRight size={16} />
              </a>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
